'use strict';

module.exports = function dump() {
  // eslint-disable-next-line
  console.log(this);
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/dump.js
// module id = 1649
// module chunks = 2